"use client";

import Link from "next/link";
import { useSelectedLayoutSegment } from "next/navigation";
import { useTranslations } from "next-intl";

export function HomeLink() {
  const segment = useSelectedLayoutSegment();
  const t = useTranslations("header.nav");

  return (
    <Link
      href="/"
      className="text-foreground/60 transition-colors hover:text-foreground"
    >
    {t("home")}
    </Link>
  );
}